<template>
<select :required="required" :value="value" @input="$emit('input', $event.target.value)" @change="$emit('change', $event)">
  <option v-if="show_null" value="">None</option>
  <optgroup v-if="types" v-for="type in types_" :label="type[1]">
    <option v-for='item in items.filter(i => i.type === type[0])' :value='item.id' v-if="(item.state==1 && (divisions===undefined || item.division_id===undefined || item.division_id===null || divisions.find(d => d == item.division_id))) || item.id == value">{{item.full}}</option>
  </optgroup>
  <option v-for='item in items' :value='item.id' v-if="!types && ((item.state==1 && (item.division_id===undefined || item.division_id===null || divisions.find(d => d == item.division_id))) || item.id == value)">{{ "__".repeat(item.depth) + " " + item.name}}</option>
</select>
</template>

<script>
export default {
    props: {
	items: Array,
	value:[ Number, String ],
	types: Array,
	divisions: Array,
	required: Boolean,
        show_null: Boolean,
        order: Array,
    },
    computed: {
      types_ : function() {
        if(this.order === null || this.order === undefined) {
          return this.types
        } else {
          var x = []
          for(var idx=0; idx<this.order.length; idx++) {
            x.push(this.types.find(t => t[1] == this.order[idx]))
          }
          return x
        }
      }
    }
}

</script>

<style scoped>




</style>
